import { HttpClient, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  IDocumentBase,
  IFuncResponse,
} from 'app/services/api5-service/api.interface';
import { Observable, OperatorFunction, pipe, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';

import { HttpResponseHandler } from './model';

import { forJsonOutputHeaders } from '../http-base.service';

/* Http Service Unavailable */
const HTTP_CODE_SERVICE_UNAVAILABLE = 503;

/**
 * Http handler service for handling long task requests
 */
@Injectable({
  providedIn: 'root',
})
export class LongTaskHandlerService
  implements HttpResponseHandler<IFuncResponse>
{
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Handle error for event base http request
   *
   * @param error - error object
   */
  private handleErrorEvent(
    error: HttpErrorResponse,
  ): Observable<HttpEvent<IFuncResponse>> {
    if (error.status === HTTP_CODE_SERVICE_UNAVAILABLE) {
      const url = error.error;
      return this.get503Event(url);
    }
    // errorEmitter handle may be here
    return throwError(error);
  }

  /**
   * Request for get response of 503 error(long request)
   *
   * @param stringParam - request params
   */
  private get503Event(
    stringParam: string,
  ): Observable<HttpEvent<IFuncResponse>> {
    const url = `/${stringParam}`;
    return this.httpClient
      .get(url, {
        headers: forJsonOutputHeaders,
        observe: 'events',
      })
      .pipe(
        catchError(error => this.handleErrorEvent(error)),
        share(),
      ) as Observable<HttpEvent<IFuncResponse>>;
  }

  /**
   * Error handler
   *
   * @param error - error object
   */
  private handleError<R extends IDocumentBase = IDocumentBase>(
    error: HttpErrorResponse,
  ): Observable<IFuncResponse<R>> {
    if (error.status === HTTP_CODE_SERVICE_UNAVAILABLE) {
      const url = error.error;
      // handle 503 error
      return this.get503<R>(url);
    }
    // errorEmitter handle may be here
    return throwError(error);
  }

  /**
   * Request for get response of 503 error(long request)
   *
   * @param stringParam - request params
   */
  private get503<R extends IDocumentBase = IDocumentBase>(
    stringParam: string,
  ): Observable<IFuncResponse<R>> {
    const url = `/${stringParam}`;

    return this.httpClient
      .get<IFuncResponse<R>>(url, { headers: forJsonOutputHeaders })
      .pipe(
        catchError(error => this.handleError<R>(error)),
        share(),
      );
  }

  /**
   * Check response for BE not available
   */
  handle(): OperatorFunction<IFuncResponse, IFuncResponse> {
    return pipe(catchError(error => this.handleError(error))) as any;
  }

  handleEvent(): OperatorFunction<
    HttpEvent<IFuncResponse>,
    HttpEvent<IFuncResponse>
  > {
    return pipe(catchError(error => this.handleErrorEvent(error))) as any;
  }
}
